/**
 * Handles setting errors on form fields
 */
export const setFormError = (setErrors: React.Dispatch<React.SetStateAction<any>>, field: string, value: string) => {
    setErrors((prevErrors: any) => ({
        ...prevErrors,
        [field]: value,
    }));
};
